import { render, staticRenderFns } from "./polygon7.vue?vue&type=template&id=4c5deb71&"
import script from "./polygon7.vue?vue&type=script&lang=ts&"
export * from "./polygon7.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports